//LOGIN
export const ADD_LOGIN = "ADD_LOGIN";
export const LOGIN_LOADING = "LOGIN_LOADING";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const REMOVE_LOGIN = "REMOVE_LOGIN";

//-----users
export const USERS_GET_DATA = "USERS_GET_DATA";
export const USERS_SET_DATA = "USERS_SET_DATA";
export const USERS_FAIL_DATA = "USERS_FAIL_DATA";
export const DELETE_USERS_FAIL = "DELETE_USERS_FAIL";
export const POST_USERS_DATA = "POST_USERS_DATA";
export const POST_USERS_DATA_START = "POST_USERS_DATA_START";
export const POST_USERS_DATA_FAIL = "POST_USERS_DATA_FAIL";
export const POST_USERS_DATA_SUCCESS = "POST_USERS_DATA_SUCCESS";
export const EDIT_USERS_ROW_START = "EDIT_USERS_ROW_START";
export const FAIL_EDIT_USERS = "FAIL_EDIT_USERS";
export const CURRENT_USER_EDIT_USERS = "CURRENT_USER_EDIT_USERS";
export const UPDATE_USERS_DATA_START = "UPDATE_USERS_DATA_START";
export const UPDATE_USERS_DATA_FAIL = "UPDATE_USERS_DATA_FAIL";
export const UPDATE_USERS_DATA_SUCCESS = "UPDATE_USERS_DATA_SUCCESS";
export const USERS_LOADING = "USERS_LOADING";
export const USERS_POST_LOADING = "USERS_POST_LOADING";
export const USERS_UPDATE_LOADING = "USERS_UPDATE_LOADING";

// batches
export const BATCHES_GET_DATA = "BATCHES_GET_DATA";
export const BATCHES_SET_DATA = "BATCHES_SET_DATA";
export const BATCHES_FAIL_DATA = "BATCHES_FAIL_DATA";
export const DELETE_BATCHES_FAIL = "DELETE_BATCHES_FAIL";
export const POST_BATCHES_DATA = "POST_BATCHES_DATA";
export const POST_BATCHES_DATA_START = "POST_BATCHES_DATA_START";
export const POST_BATCHES_DATA_FAIL = "POST_BATCHES_DATA_FAIL";
export const POST_BATCHES_DATA_SUCCESS = "POST_BATCHES_DATA_SUCCESS";
export const EDIT_BATCHES_ROW_START = "EDIT_BATCHES_ROW_START";
export const FAIL_EDIT_BATCHES = "FAIL_EDIT_BATCHES";
export const UPDATE_BATCHES_DATA_START = "UPDATE_BATCHES_DATA_START";
export const UPDATE_BATCHES_DATA_FAIL = "UPDATE_BATCHES_DATA_FAIL";
export const UPDATE_BATCHES_DATA_SUCCESS = "UPDATE_BATCHES_DATA_SUCCESS";
export const BATCHES_LOADING = "BATCHES_LOADING";
export const BATCHES_POST_LOADING = "BATCHES_POST_LOADING";
export const BATCHES_UPDATE_LOADING = "BATCHES_UPDATE_LOADING";

// courses COURSES
export const COURSES_GET_DATA = "COURSES_GET_DATA";
export const COURSES_SET_DATA = "COURSES_SET_DATA";
export const COURSES_FAIL_DATA = "COURSES_FAIL_DATA";
export const DELETE_COURSES_FAIL = "DELETE_COURSES_FAIL";
export const POST_COURSES_DATA = "POST_COURSES_DATA";
export const POST_COURSES_DATA_START = "POST_COURSES_DATA_START";
export const POST_COURSES_DATA_FAIL = "POST_COURSES_DATA_FAIL";
export const POST_COURSES_DATA_SUCCESS = "POST_COURSES_DATA_SUCCESS";
export const EDIT_COURSES_ROW_START = "EDIT_COURSES_ROW_START";
export const FAIL_EDIT_COURSES = "FAIL_EDIT_COURSES";
export const UPDATE_COURSES_DATA_START = "UPDATE_COURSES_DATA_START";
export const UPDATE_COURSES_DATA_FAIL = "UPDATE_COURSES_DATA_FAIL";
export const UPDATE_COURSES_DATA_SUCCESS = "UPDATE_COURSES_DATA_SUCCESS";
export const COURSES_LOADING = "COURSES_LOADING";
export const COURSES_POST_LOADING = "COURSES_POST_LOADING";
export const COURSES_UPDATE_LOADING = "COURSES_UPDATE_LOADING";

// branches
export const BRANCHES_GET_DATA = "BRANCHES_GET_DATA";
export const BRANCHES_SET_DATA = "BRANCHES_SET_DATA";
export const BRANCHES_FAIL_DATA = "BRANCHES_FAIL_DATA";
export const DELETE_BRANCHES_FAIL = "DELETE_BRANCHES_FAIL";
export const POST_BRANCHES_DATA = "POST_BRANCHES_DATA";
export const POST_BRANCHES_DATA_START = "POST_BRANCHES_DATA_START";
export const POST_BRANCHES_DATA_FAIL = "POST_BRANCHES_DATA_FAIL";
export const POST_BRANCHES_DATA_SUCCESS = "POST_BRANCHES_DATA_SUCCESS";
export const EDIT_BRANCHES_ROW_START = "EDIT_BRANCHES_ROW_START";
export const FAIL_EDIT_BRANCHES = "FAIL_EDIT_BRANCHES";
export const UPDATE_BRANCHES_DATA_START = "UPDATE_BRANCHES_DATA_START";
export const UPDATE_BRANCHES_DATA_FAIL = "UPDATE_BRANCHES_DATA_FAIL";
export const UPDATE_BRANCHES_DATA_SUCCESS = "UPDATE_BRANCHES_DATA_SUCCESS";
export const BRANCHES_LOADING = "BRANCHES_LOADING";
export const BRANCHES_POST_LOADING = "BRANCHES_POST_LOADING";
export const BRANCHES_UPDATE_LOADING = "BRANCHES_UPDATE_LOADING";

// course-registration COURSE_REG
export const COURSE_REG_GET_DATA = "COURSE_REG_GET_DATA";
export const COURSE_REG_SET_DATA = "COURSE_REG_SET_DATA";
export const COURSE_REG_FAIL_DATA = "COURSE_REG_FAIL_DATA";
export const DELETE_COURSE_REG_FAIL = "DELETE_COURSE_REG_FAIL";
export const POST_COURSE_REG_DATA = "POST_COURSE_REG_DATA";
export const POST_COURSE_REG_DATA_START = "POST_COURSE_REG_DATA_START";
export const POST_COURSE_REG_DATA_FAIL = "POST_COURSE_REG_DATA_FAIL";
export const POST_COURSE_REG_DATA_SUCCESS = "POST_COURSE_REG_DATA_SUCCESS";
export const EDIT_COURSE_REG_ROW_START = "EDIT_COURSE_REG_ROW_START";
export const FAIL_EDIT_COURSE_REG = "FAIL_EDIT_COURSE_REG";
export const UPDATE_COURSE_REG_DATA_START = "UPDATE_COURSE_REG_DATA_START";
export const UPDATE_COURSE_REG_DATA_FAIL = "UPDATE_COURSE_REG_DATA_FAIL";
export const UPDATE_COURSE_REG_DATA_SUCCESS = "UPDATE_COURSE_REG_DATA_SUCCESS";
export const COURSE_REG_LOADING = "COURSE_REG_LOADING";
export const COURSE_REG_POST_LOADING = "COURSE_REG_POST_LOADING";
export const COURSE_REG_POST_LOADING_RESET = "COURSE_REG_POST_LOADING_RESET";
export const COURSE_REG_UPDATE_LOADING = "COURSE_REG_UPDATE_LOADING";

// course-bY-EVENTS 
export const COURSE_BY_EVENTS_GET_DATA = "COURSE_BY_EVENTS_GET_DATA";
export const COURSE_BY_EVENTS_SET_DATA = "COURSE_BY_EVENTS_SET_DATA";
export const COURSE_BY_EVENTS_FAIL_DATA = "COURSE_BY_EVENTS_FAIL_DATA";
export const COURSE_BY_EVENTS_LOADING = "COURSE_BY_EVENTS_LOADING";

// events
export const EVENTS_GET_DATA = "EVENTS_GET_DATA";
export const EVENTS_SET_DATA = "EVENTS_SET_DATA";
export const EVENTS_FAIL_DATA = "EVENTS_FAIL_DATA";
export const DELETE_EVENTS_FAIL = "DELETE_EVENTS_FAIL";
export const POST_EVENTS_DATA = "POST_EVENTS_DATA";
export const POST_EVENTS_DATA_START = "POST_EVENTS_DATA_START";
export const POST_EVENTS_DATA_FAIL = "POST_EVENTS_DATA_FAIL";
export const POST_EVENTS_DATA_SUCCESS = "POST_EVENTS_DATA_SUCCESS";
export const EDIT_EVENTS_ROW_START = "EDIT_EVENTS_ROW_START";
export const FAIL_EDIT_EVENTS = "FAIL_EDIT_EVENTS";
export const UPDATE_EVENTS_DATA_START = "UPDATE_EVENTS_DATA_START";
export const UPDATE_EVENTS_DATA_FAIL = "UPDATE_EVENTS_DATA_FAIL";
export const UPDATE_EVENTS_DATA_SUCCESS = "UPDATE_EVENTS_DATA_SUCCESS";
export const EVENTS_LOADING = "EVENTS_LOADING";
export const EVENTS_POST_LOADING = "EVENTS_POST_LOADING";
export const EVENTS_UPDATE_LOADING = "EVENTS_UPDATE_LOADING";

// teachers
export const TEACHERS_GET_DATA = "TEACHERS_GET_DATA";
export const TEACHERS_SET_DATA = "TEACHERS_SET_DATA";
export const TEACHERS_FAIL_DATA = "TEACHERS_FAIL_DATA";
export const DELETE_TEACHERS_FAIL = "DELETE_TEACHERS_FAIL";
export const POST_TEACHERS_DATA = "POST_TEACHERS_DATA";
export const POST_TEACHERS_DATA_START = "POST_TEACHERS_DATA_START";
export const POST_TEACHERS_DATA_FAIL = "POST_TEACHERS_DATA_FAIL";
export const POST_TEACHERS_DATA_SUCCESS = "POST_TEACHERS_DATA_SUCCESS";
export const EDIT_TEACHERS_ROW_START = "EDIT_TEACHERS_ROW_START";
export const FAIL_EDIT_TEACHERS = "FAIL_EDIT_TEACHERS";
export const UPDATE_TEACHERS_DATA_START = "UPDATE_TEACHERS_DATA_START";
export const UPDATE_TEACHERS_DATA_FAIL = "UPDATE_TEACHERS_DATA_FAIL";
export const UPDATE_TEACHERS_DATA_SUCCESS = "UPDATE_TEACHERS_DATA_SUCCESS";
export const TEACHERS_LOADING = "TEACHERS_LOADING";
export const TEACHERS_POST_LOADING = "TEACHERS_POST_LOADING";
export const TEACHERS_UPDATE_LOADING = "TEACHERS_UPDATE_LOADING";

// weekDays
export const WEEK_DAYS_GET_DATA = "WEEK_DAYS_GET_DATA";
export const WEEK_DAYS_SET_DATA = "WEEK_DAYS_SET_DATA";
export const WEEK_DAYS_FAIL_DATA = "WEEK_DAYS_FAIL_DATA";
export const DELETE_WEEK_DAYS_FAIL = "DELETE_WEEK_DAYS_FAIL";
export const POST_WEEK_DAYS_DATA = "POST_WEEK_DAYS_DATA";
export const POST_WEEK_DAYS_DATA_START = "POST_WEEK_DAYS_DATA_START";
export const POST_WEEK_DAYS_DATA_FAIL = "POST_WEEK_DAYS_DATA_FAIL";
export const POST_WEEK_DAYS_DATA_SUCCESS = "POST_WEEK_DAYS_DATA_SUCCESS";
export const EDIT_WEEK_DAYS_ROW_START = "EDIT_WEEK_DAYS_ROW_START";
export const FAIL_EDIT_WEEK_DAYS = "FAIL_EDIT_WEEK_DAYS";
export const UPDATE_WEEK_DAYS_DATA_START = "UPDATE_WEEK_DAYS_DATA_START";
export const UPDATE_WEEK_DAYS_DATA_FAIL = "UPDATE_WEEK_DAYS_DATA_FAIL";
export const UPDATE_WEEK_DAYS_DATA_SUCCESS = "UPDATE_WEEK_DAYS_DATA_SUCCESS";
export const WEEK_DAYS_LOADING = "WEEK_DAYS_LOADING";
export const WEEK_DAYS_POST_LOADING = "WEEK_DAYS_POST_LOADING";
export const WEEK_DAYS_UPDATE_LOADING = "WEEK_DAYS_UPDATE_LOADING";

export const LEVEL_GET_DATA = "LEVEL_GET_DATA";
export const LEVEL_SET_DATA = "LEVEL_SET_DATA";
export const LEVEL_FAIL_DATA = "LEVEL_FAIL_DATA";
export const DELETE_LEVEL_FAIL = "DELETE_LEVEL_FAIL";
export const POST_LEVEL_DATA = "POST_LEVEL_DATA";
export const POST_LEVEL_DATA_START = "POST_LEVEL_DATA_START";
export const POST_LEVEL_DATA_FAIL = "POST_LEVEL_DATA_FAIL";
export const POST_LEVEL_DATA_SUCCESS = "POST_LEVEL_DATA_SUCCESS";
export const EDIT_LEVEL_ROW_START = "EDIT_LEVEL_ROW_START";
export const FAIL_EDIT_LEVEL = "FAIL_EDIT_LEVEL";
export const UPDATE_LEVEL_DATA_START = "UPDATE_LEVEL_DATA_START";
export const UPDATE_LEVEL_DATA_FAIL = "UPDATE_LEVEL_DATA_FAIL";
export const UPDATE_LEVEL_DATA_SUCCESS = "UPDATE_LEVEL_DATA_SUCCESS";
export const LEVEL_LOADING = "LEVEL_LOADING";
export const LEVEL_POST_LOADING = "LEVEL_POST_LOADING";
export const LEVEL_UPDATE_LOADING = "LEVEL_UPDATE_LOADING";

// payu-payment PAYU_PAYMENT payuPayment
export const PAYU_PAYMENT_GET_DATA = "PAYU_PAYMENT_GET_DATA";
export const PAYU_PAYMENT_SET_DATA = "PAYU_PAYMENT_SET_DATA";
export const PAYU_PAYMENT_FAIL_DATA = "PAYU_PAYMENT_FAIL_DATA";
export const DELETE_PAYU_PAYMENT_FAIL = "DELETE_PAYU_PAYMENT_FAIL";
export const POST_PAYU_PAYMENT_DATA = "POST_PAYU_PAYMENT_DATA";
export const POST_PAYU_PAYMENT_DATA_START = "POST_PAYU_PAYMENT_DATA_START";
export const POST_PAYU_PAYMENT_DATA_FAIL = "POST_PAYU_PAYMENT_DATA_FAIL";
export const POST_PAYU_PAYMENT_DATA_SUCCESS = "POST_PAYU_PAYMENT_DATA_SUCCESS";
export const EDIT_PAYU_PAYMENT_ROW_START = "EDIT_PAYU_PAYMENT_ROW_START";
export const FAIL_EDIT_PAYU_PAYMENT = "FAIL_EDIT_PAYU_PAYMENT";
export const UPDATE_PAYU_PAYMENT_DATA_START = "UPDATE_PAYU_PAYMENT_DATA_START";
export const UPDATE_PAYU_PAYMENT_DATA_FAIL = "UPDATE_PAYU_PAYMENT_DATA_FAIL";
export const UPDATE_PAYU_PAYMENT_DATA_SUCCESS = "UPDATE_PAYU_PAYMENT_DATA_SUCCESS";
export const PAYU_PAYMENT_LOADING = "PAYU_PAYMENT_LOADING";
export const PAYU_PAYMENT_POST_LOADING = "PAYU_PAYMENT_POST_LOADING";
export const PAYU_PAYMENT_UPDATE_LOADING = "PAYU_PAYMENT_UPDATE_LOADING";

export const ONLINE_CLASS_GET_DATA = "ONLINE_CLASS_GET_DATA";
export const ONLINE_CLASS_SET_DATA = "ONLINE_CLASS_SET_DATA";
export const ONLINE_CLASS_FAIL_DATA = "ONLINE_CLASS_FAIL_DATA";
export const DELETE_ONLINE_CLASS_FAIL = "DELETE_ONLINE_CLASS_FAIL";
export const POST_ONLINE_CLASS_DATA = "POST_ONLINE_CLASS_DATA";
export const POST_ONLINE_CLASS_DATA_START = "POST_ONLINE_CLASS_DATA_START";
export const POST_ONLINE_CLASS_DATA_FAIL = "POST_ONLINE_CLASS_DATA_FAIL";
export const POST_ONLINE_CLASS_DATA_SUCCESS = "POST_ONLINE_CLASS_DATA_SUCCESS";
export const EDIT_ONLINE_CLASS_ROW_START = "EDIT_ONLINE_CLASS_ROW_START";
export const FAIL_EDIT_ONLINE_CLASS = "FAIL_EDIT_ONLINE_CLASS";
export const UPDATE_ONLINE_CLASS_DATA_START = "UPDATE_ONLINE_CLASS_DATA_START";
export const UPDATE_ONLINE_CLASS_DATA_FAIL = "UPDATE_ONLINE_CLASS_DATA_FAIL";
export const UPDATE_ONLINE_CLASS_DATA_SUCCESS = "UPDATE_ONLINE_CLASS_DATA_SUCCESS";
export const ONLINE_CLASS_LOADING = "ONLINE_CLASS_LOADING";
export const ONLINE_CLASS_POST_LOADING = "ONLINE_CLASS_POST_LOADING";
export const ONLINE_CLASS_UPDATE_LOADING = "ONLINE_CLASS_UPDATE_LOADING";
